module.exports = __webpack_public_path__ + "img/MaschineRobot.cf9ab988.png";